'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const FunnelIcon = ({ sx, isSelected }) => {
  return (
    <SvgIcon sx={sx} data-testid="FunnelIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Filter-1--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Filter 1 Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M21.8 2.1A1 1 0 0 0 21 0.5H2.981a1 1 0 0 0 -0.8 1.6l7.808 10.491V22.5a1 1 0 0 0 1.6 0.8l2 -1.5a1 1 0 0 0 0.4 -0.8v-8.41Z"
          fill={isSelected ? sx?.color || '#333333' : 'none'}
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

FunnelIcon.propTypes = {
  sx: PropTypes.object,
  isSelected: PropTypes.bool
}
